module.exports = __webpack_public_path__ + "img/task(15).aab647cb.png";